function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.329,
    height: 25.907,
    viewBox: "0 0 23.329 25.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7500",
    d: "M-118.32-154.693a5.6 5.6 0 0 1 1.385-1.685 7.121 7.121 0 0 1 2.15-1.221l.284-4.124q-.655-.371-1.213-.757a10.943 10.943 0 0 1-.969-.743 4.673 4.673 0 0 1-.641-.66 1.507 1.507 0 0 1-.354-.92.954.954 0 0 1 .31-.73 1.135 1.135 0 0 1 .805-.287h9.522a1.138 1.138 0 0 1 .806.287.956.956 0 0 1 .309.73 1.484 1.484 0 0 1-.363.92 4.675 4.675 0 0 1-.641.66 10.722 10.722 0 0 1-.965.739q-.552.381-1.216.761l.292 4.124a7.113 7.113 0 0 1 2.15 1.221 5.618 5.618 0 0 1 1.385 1.685 4.032 4.032 0 0 1 .482 1.881 1.294 1.294 0 0 1-.376.969 1.392 1.392 0 0 1-1.014.367h-4.725v4.195a4.069 4.069 0 0 1-.1.907 4.923 4.923 0 0 1-.252.806 3.415 3.415 0 0 1-.3.575q-.145.216-.235.216t-.243-.216a3.239 3.239 0 0 1-.292-.575 5.221 5.221 0 0 1-.248-.806 4.069 4.069 0 0 1-.1-.907v-4.195h-4.725a1.392 1.392 0 0 1-1.009-.367 1.284 1.284 0 0 1-.381-.969 4.032 4.032 0 0 1 .482-1.881z",
    transform: "rotate(30 -364.031 159.22)",
    style: {
      fill: "#fff",
      stroke: "#175664",
      strokeWidth: ".5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvik);
export default __webpack_public_path__ + "static/media/cvik.35f992aa.svg";
export { ForwardRef as ReactComponent };